import React, { useState } from 'react';
import { UserInfoBanner } from './UserInfoBanner';
import { InfoCards } from './InfoCards';
import { TabNavigation } from './TabNavigation';
import { AnnouncementSection } from './AnnouncementSection';
import { ActiveForms } from './ActiveForms';
import { DocumentManagement } from './DocumentManagement';
import { WorkflowManagement } from './WorkflowManagement';
import { ArchiveManagement } from './ArchiveManagement';
import { UserManagement } from './UserManagement';
import { ReportingDashboard } from './ReportingDashboard';
import { BarChart, FileText, FolderOpen, Clock, Users, Calendar, ArrowRight, TrendingUp, CheckCircle, AlertCircle, Filter, Search, Plus, RefreshCw, PieChart } from 'lucide-react';
export const Dashboard = ({
  activeDepartment,
  setActiveDepartment,
  activeModule,
  setActiveModule
}) => {
  const [activeView, setActiveView] = useState('home');
  // If activeModule is set from Sidebar, use that to determine what to render
  if (activeModule === 'users') {
    return <UserManagement activeDepartment={activeDepartment} setActiveDepartment={setActiveDepartment} data-id="element-179" />;
  }
  if (activeModule === 'reports') {
    return <ReportingDashboard activeDepartment={activeDepartment} setActiveDepartment={setActiveDepartment} data-id="element-180" />;
  }
  // Handle the existing views
  if (activeView === 'documents' || activeModule === 'documents') {
    return <DocumentManagement activeDepartment={activeDepartment} setActiveDepartment={setActiveDepartment} data-id="element-181" />;
  }
  if (activeView === 'workflows' || activeModule === 'workflows') {
    return <WorkflowManagement activeDepartment={activeDepartment} setActiveDepartment={setActiveDepartment} data-id="element-182" />;
  }
  if (activeView === 'archive' || activeModule === 'archives') {
    return <ArchiveManagement activeDepartment={activeDepartment} setActiveDepartment={setActiveDepartment} data-id="element-183" />;
  }
  // Dashboard Home
  return <div className="flex-1 overflow-auto" data-id="element-184">
      <UserInfoBanner data-id="element-185" />
      <InfoCards data-id="element-186" />
      <div className="px-4 py-2" data-id="element-187">
        <TabNavigation activeDepartment={activeDepartment} setActiveDepartment={setActiveDepartment} setActiveView={setActiveView} activeView={activeView} data-id="element-188" />
        <div className="mt-8" data-id="element-189">
          <AnnouncementSection data-id="element-190" />
        </div>
        <div className="mt-8" data-id="element-191">
          <ActiveForms data-id="element-192" />
        </div>
        <div className="mt-8" data-id="element-193">
          <DashboardQuickAccess setActiveView={setActiveView} setActiveModule={setActiveModule} data-id="element-194" />
        </div>
      </div>
    </div>;
};
const DashboardQuickAccess = ({
  setActiveView,
  setActiveModule
}) => {
  return <div className="bg-white rounded-lg shadow-sm p-6 mb-8" data-id="element-195">
      <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-196">Quick Actions</h2>
      <div className="grid grid-cols-5 gap-4" data-id="element-197">
        <QuickActionButton label="Manage Documents" icon={<FileText className="h-5 w-5" data-id="element-199" />} onClick={() => setActiveView('documents')} data-id="element-198" />
        <QuickActionButton label="Manage Workflows" icon={<Clock className="h-5 w-5" data-id="element-201" />} onClick={() => setActiveView('workflows')} data-id="element-200" />
        <QuickActionButton label="View Archives" icon={<FolderOpen className="h-5 w-5" data-id="element-203" />} onClick={() => setActiveView('archive')} data-id="element-202" />
        <QuickActionButton label="Manage Users" icon={<Users className="h-5 w-5" data-id="element-205" />} onClick={() => setActiveModule('users')} data-id="element-204" />
        <QuickActionButton label="View Reports" icon={<PieChart className="h-5 w-5" data-id="element-207" />} onClick={() => setActiveModule('reports')} data-id="element-206" />
      </div>
    </div>;
};
const QuickActionButton = ({
  label,
  icon,
  onClick
}) => {
  return <button className="flex flex-col items-center justify-center p-4 border border-gray-200 rounded-lg hover:bg-blue-50 hover:border-blue-200 transition-colors" onClick={onClick} data-id="element-208">
      <div className="h-10 w-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 mb-2" data-id="element-209">
        {icon}
      </div>
      <span className="text-sm text-gray-700" data-id="element-210">{label}</span>
    </button>;
};